<div class="sidebar-switch-role">
    <div class="sidebar-switch-role-title">
        <button class="sidebar-switch-role-title__back" (click)="backClicked.emit()"><mat-icon>arrow_back</mat-icon>Back</button>
        <div class="sidebar-switch-role-title__text">Switch Role/Org</div>
    </div>

    <app-sidebar-user-info class="sidebar-user-info" [currentUser]="currentUser" [isSwitchRole]="true"></app-sidebar-user-info>

    <div class="sidebar-switch-role-list">
        <ng-container *ngIf="user && user.assignedRoleList && user.assignedRoleList.length">
            <div class="role-block">
                <div class="role-block__title">My roles (click to switch)</div>
                <div *ngFor="let role of user.assignedRoleList" class="role-block__item" [class.active]="user.roleId == role.roleId">
                    <mat-radio-group>
                        <mat-radio-button [checked]="user.roleId === role.roleId" [value]="role.roleId" (change)="switchRole(role)"
                            ><span class="role-name">{{ role.roleName }}</span></mat-radio-button
                        >
                    </mat-radio-group>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="user && user.businessUnitList && user.businessUnitList.length">
            <div class="role-block">
                <div class="role-block__title">My organization (click to switch)</div>
                <div *ngFor="let org of user.businessUnitList" class="role-block__item" [class.active]="user.businessUnitId == org.id">
                    <mat-radio-group>
                        <mat-radio-button [checked]="user.businessUnitId === org.id" [value]="org.id" (change)="switchOrganization(org)"
                            ><span class="role-name">{{ org.name }}</span>
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </ng-container>
    </div>
</div>
